export default "__VITE_ASSET__CiR4irIj__"